import { render, staticRenderFns } from "./Create-Member.vue?vue&type=template&id=f752887a"
import script from "./Create-Member.vue?vue&type=script&lang=js"
export * from "./Create-Member.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports